// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class Message extends TrackingModel {
	public MessageId: number = 0;
	public FromContactId: number = 0;
	public Subject: string = "";
	public Body?: string;
	public SendAfterUTC?: Date;
	public SentOnUTC?: Date;
}